module.exports = __webpack_public_path__ + "img/btg.f4567f5c.svg";